import React from 'react';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { getName,getEmail,isAuthenticatedUser } from '../common';

const TopBar = (props) => {
    const email = getEmail();
    const name = getName();
    const isAuthenticated = isAuthenticatedUser();
    const [menuUsr, setMenuUsr] = React.useState(null);
    const openUsr = Boolean(menuUsr);
    
    const handleClickUsr = (event) => {
        setMenuUsr(event.currentTarget);
    };
    const handleCloseUsr = (event) => {
        setMenuUsr(null);
    };

    const handleLogout = (event) => {
        setMenuUsr(null);
    };
    return (
        <>
             <nav className="navbar navbar-header navbar-expand navbar-light">
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul className="navbar-nav d-flex align-items-center navbar-light ml-auto">
                                        <li className="dropdown">
                                            <a href="#" data-toggle="dropdown" className="nav-link dropdown-toggle nav-link-lg nav-link-user">
                                                <div className="avatar mr-1">

                                                </div>
                                                <div className="d-none d-md-block d-lg-inline-block" style={{ border: 'none', background: 'transparent', fontFamily: 'Open Sans', color: '#6c757d', fontWeight: '600' }}>
                                                    {/* Hi, {accounts[0].name} */}
                                                    <Stack className="headerPanel" direction="row" spacing={0}>
                                                        <div className="headerDiv">
                                                            {isAuthenticated ? (
                                                                <div className="userSpan">
                                                                    <Typography>
                                                                   
                                                                    Welcome {name} <span style={{color:"#002677"}}>({(props.role ==="admin"||props.role==="manager"||props.role==='off-admin')?"Manager":"Auditor"})</span>
 
                                                                        <IconButton
                                                                            className="iconBtn"
                                                                            onClick={handleClickUsr}
                                                                        >
                                                                            <AccountCircleIcon className="userIcon" />
                                                                        </IconButton>
                                                                    </Typography>

                                                                    <Menu anchorEl={menuUsr} open={openUsr} onClose={handleCloseUsr}>
                                                                        <MenuItem className="menuList" onClick={handleCloseUsr}>
                                                                            {name}
                                                                        </MenuItem>
                                                                        <MenuItem className="menuList" onClick={handleCloseUsr}>
                                                                            {email}
                                                                        </MenuItem>
                                                                        <Divider />
                                                                        {/* <MenuItem className="menuList" onClick={handleLogout}>
                                                                            <ListItemIcon>
                                                                                <Logout fontSize="small" />
                                                                            </ListItemIcon>
                                                                            Logout
                                                                        </MenuItem> */}
                                                                    </Menu>
                                                                </div>
                                                            ) : (
                                                                <Typography className="userSpan">
                                                                    <IconButton>
                                                                        <AccountCircleIcon className="userIcon" />
                                                                    </IconButton>
                                                                </Typography>
                                                            )}
                                                        </div>
                                                    </Stack>
                                            </div>
                                        </a>

                                    </li>
                                </ul>
                            </div>
                        </nav>
            </>
    )
}
export default TopBar
